<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <input-mask mask="9999-99-99" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
            </div>
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button @click.prevent="searchSalesReturn"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
              <!-- <button type="submit" style="margin-left:10px" v-if="this.salesReturnList.length > 0"  @click.prevent="reset"
              class="btn btn-info pull-left">Reset</button> -->
            </div>
          </div>
        </form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
            <a href="#" @click.prevent="exportCSV()" v-if="this.salesReturnList.length > 0 && this.$store.getters.modules.includes('5.38')">
              <img src="../../../../static/img/excel.png" style="margin-left: 90em;height: 3em;width: 3em;"/>
            </a>
            <DataTable :value="salesReturnLists"
                       :paginator="true" ref="po"
                       :rowsPerPageOptions="[100,500,1000]"
                       :rows="100" :filters="filters"
                       class="p-datatable-responsive p-datatable-gridlines"
                       data-key="id"
                       :selection.sync="selectedProduct1" selectionMode="single">
              <Column header="S.N" field="id"/>
              <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="purchaseSalesDateNepali" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseSalesDateNepali']"/>
                </template>
              </Column>
              <Column header="Date" headerStyle="width:8em;" :sortable="true" field="purchaseDate" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['purchaseDate']"/>
                </template>
              </Column>
              <Column header="Return No" :sortable="true" field="returnNo" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['returnNo']"/>
                </template>
              </Column>
              <Column header="Customer" :sortable="true" field="accountName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
                </template>
              </Column>
              <Column header="Address" :sortable="true" field="address" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
                </template>
              </Column>
              <Column header="Store" :sortable="true" field="warehouse.name" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['warehouse.name']"/>
                </template>
              </Column>
              <Column header="Sub Total" bodyStyle="text-align: right" :sortable="true" field="subTotalAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['address']"/>
                </template>
              </Column>

              <Column header="Non-taxable" bodyStyle="text-align: right" :sortable="true" field="nonTaxableAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['nonTaxableAmount']"/>
                </template>
              </Column>

              <Column header="Taxable" bodyStyle="text-align: right" :sortable="true" field="taxableAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['taxableAmount']"/>
                </template>
              </Column>
              <Column header="Vat" bodyStyle="text-align: right" :sortable="true" field="vatAmount"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['vatAmount']"/>
                </template>
              </Column>

              <Column header="Total" bodyStyle="text-align: right" field="totalBillAmount" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['totalBillAmount']"/>
                </template>
              </Column>
              <Column header="Org Name" :sortable="true" field="organisationName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['organisationName']"/>
                </template>
              </Column>
              <!-- <Column header="Action" headerStyle="width:14em;">
               <template #body="slotProps">
                  <Button type="submit" v-if="enableEdit" class="p-button-raised p-button-success" style="marginn-left:5px" @click="editSalesReturn(slotProps.data)">
                    <i class="fa fa-edit"  />
                    </Button>
                    <Button type="submit" v-else disabled class="p-button-raised p-button-success" style="marginn-left:5px" @click="editSalesReturn(slotProps.data)">
                    <i class="fa fa-edit"  />
                    </Button>

                  <Button type="button" v-if="enableDelete" class="p-button-raised p-button-danger"  style="marginn-left:5px"
                  @click="openDialog(slotProps.data.id)">
                  <i class="fa fa-trash" /></Button>
                  <Button type="button" v-else disabled class="p-button-raised p-button-danger"  style="marginn-left:5px"
                  @click="openDialog(slotProps.data.id)">
                  <i class="fa fa-trash" /></Button>

                  <Button type="button" class="p-button-raised" @click="viewPIVDetail(slotProps.data)"
                  ><i class="fa fa-eye" aria-hidden="true"></i></Button>

                  <Button class="p-button-raised p-button-secondary" @click="exportToPdf(slotProps.data.id)" >
                    <i class="fa fa-print" aria-hidden="true"></i>
                    </Button>
                 </div>
              </div>
            </template>
          </Column> -->
              <Column header="Action" headerStyle="width:14em;">
                <template #body="slotProps">
                  <!-- Edit Button -->
                  <Button icon="pi pi-pencil" v-if="$store.getters.modules.includes(',5.08')"
                          class="p-button-raised p-button-success"
                          @click="editSalesReturn(slotProps.data)"/>
                  <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success"
                          @click="editSalesReturn(slotProps.data)"/>
                  <!-- Edit button -->
                  <!-- DeleteButton -->
                  <Button v-if="enableDelete" class="p-button-raised p-button-danger"
                          @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                  <Button v-else disabled class="p-button-raised p-button-danger"
                          @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                  <!-- Delete Button -->
                  <Button class="p-button-raised" @click="viewPIVDetail(slotProps.data)"
                          icon="pi pi-eye"/>
                  <Button class="p-button-raised p-button-secondary"
                          @click="exportToPdf(slotProps.data.id)"
                          icon="pi pi-print"/>
                </template>
              </Column>
              <template #empty>No record found</template>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import axios from 'axios'
import globalKey from '../../../store/globalKey'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'

export default {
  name: 'salesReturnReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      salesReturnList: [],
      loading: false,
      dialogShow: false,
      selectedProduct1: null,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      enableEdit: false,
      enableDelete: false
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableEdit()
    this.checkEnableDelete()
  },
  computed: {
    salesReturnLists() {
      return this.$store.state.sales.salesReturnLists
    }
  },
  methods: {
    async searchSalesReturn() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.loading = true
      try {
        let resp = await this.$store.dispatch('loadSalesReturnLists', dat)
        console.log(resp)
        this.loading = false
        if (resp.data.data.length <= 0) {
          this.salesReturnList = []
        } else {
          this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
          this.salesReturnList = resp.data.data
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went Wrong!', life: 3000})
        return
      }
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        warehouse: data.warehouse,
        account: data.accountMaster,
        salesDate: data.purchaseSalesDateNepali,
        returnNo: data.returnNo,
        reportType: data.reportType,
        referenceNumber: data.referenceNumber,
        subTotalAmount: data.subTotalAmount,
        nonTaxableAmount: data.nonTaxableAmount,
        taxableAmount: data.taxableAmount,
        vatAmount: data.vatAmount,
        totalBillAmount: data.totalBillAmount,
        vatTypeEnum: data.vatTypeEnum,
        discountAmt: data.discount,
        remarks: data.remarks
      }
      this.$router.push({name: 'purchase Detail Report', params: {purchaseHeaderObj: PIHdata}})
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.08')) {
        this.enableEdit = true
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.13')) {
        this.enableDelete = true
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/salesReturn' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'salesReturn.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printPurchaseBill/' + SOHeaderId + '/salesReturn' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesReturn.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    editSalesReturn(data) {
      this.$router.push({name: 'Sales Return(Cr. Note)', params: {salesReturn: data}})
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.show = true
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteSalesReturn', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 3000})
      }
      this.dialogShow = false
    },
    reset() {
      this.salesReturnList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    Button,
    InputMask
  }
}
</script>

<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// salesReturnReport.vue?1dc7be58